module.exports = __webpack_public_path__ + "images/psp/PSPVideo/security-features.png";